import { useTranslation } from "react-i18next";
import { CardResponseItem } from "../../../Redux/Api/Request/Cards";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/pro-solid-svg-icons";

type CheckedInRendererProps = {
    card: CardResponseItem;
    familyCards?: boolean;
    small?: boolean;
};

export default function CheckedInRenderer(props: CheckedInRendererProps) {
    const { card, familyCards, small } = props;
    const { t } = useTranslation();

    const getStatusDetails = () => {
        if (familyCards && card.currentlyCheckedInNumber) {
            return {
                icon: <FontAwesomeIcon icon={faCheck} className="mr-1 text-sm" />,
                text: `${card.currentlyCheckedInNumber} / ${card.numberOfPeople}`,
            };
        }

        if (familyCards) {
            return {
                icon: <FontAwesomeIcon icon={faXmark} className="mr-1 text-sm" />,
                text: `0 / ${card.numberOfPeople}`,
            };
        }

        if (card.isCheckedIn) {
            return {
            icon: <FontAwesomeIcon icon={faCheck} className="mr-1 text-sm" />,
                text: t("cards:list:yes"),
        };
        }

        return {
            icon: <FontAwesomeIcon icon={faXmark} className="mr-1 text-sm" />,
            text: t("cards:list:no"),
        };
    };

    const { icon, text } = getStatusDetails();

    return (
        <div className="flex justify-start">
            <div className="flex justify-center items-center border border-[#D7E3F2] text-black px-3 py-2 rounded-[20px] bg-white">
                {!small && icon}
                {text}
            </div>
        </div>
    );
}
